import { type IconGlyph } from '../types';

import { AmountApprovedCheckErrorIcon } from './AmountApprovedCheckErrorIcon';
import { AmountApprovedCheckSuccessIcon } from './AmountApprovedCheckSuccessIcon';
import { AmountCheckErrorIcon } from './AmountCheckErrorIcon';
import { AmountCheckSuccessIcon } from './AmountCheckSuccessIcon';
import { ArticleErrorIcon } from './ArticleErrorIcon';
import { ArticleExistsCheckErrorIcon } from './ArticleExistsCheckErrorIcon';
import { ArticleExistsCheckSuccessIcon } from './ArticleExistsCheckSuccessIcon';
import { ArticleOutlinedIcon } from './ArticleOutlinedIcon';
import { ArticleSuccessIcon } from './ArticleSuccessIcon';
import { AttentionIcon } from './AttentionIcon';
import { AttentionIconLight } from './AttentionIconLight';
import { ConsignmentIcon } from './ConsignmentIcon';
import { CostCenterIcon } from './CostCenterIcon';
import { CreateDeliveryOutlinedIcon } from './CreateDeliveryOutlinedIcon';
import { DataExchangeConfirmedIcon } from './DataExchangeConfirmedIcon';
import { DataExchangeInterestedIcon } from './DataExchangeInterestedIcon';
import { DataExchangeLiveIcon } from './DataExchangeLiveIcon';
import { DataExchangeOnHoldIcon } from './DataExchangeOnHoldIcon';
import { DataExchangeQrCodeIcon } from './DataExchangeQrCodeIcon';
import { DataExchangeQualificationIcon } from './DataExchangeQualificationIcon';
import { DataExchangeSuccessIcon } from './DataExchangeSuccessIcon';
import { DataExchangeSupplierIcon } from './DataExchangeSupplierIcon';
import { DataExchangeTestDataIcon } from './DataExchangeTestDataIcon';
import { DataExchangeTestPhaseIcon } from './DataExchangeTestPhaseIcon';
import { DataExchangeVestigasIcon } from './DataExchangeVestigasIcon';
import { DeclinedIcon } from './DeclinedIcon';
import { DeclinedIconLight } from './DeclinedIconLight';
import { DeclinedIconLightGrey } from './DeclinedIconLightGrey';
import { DeliveryIcon } from './DeliveryIcon';
import { DeliveryOutlinedIcon } from './DeliveryOutlinedIcon';
import { DlnCheckErrorIcon } from './DlnCheckErrorIcon';
import { DlnCheckSuccessIcon } from './DlnCheckSuccessIcon';
import { DoneIconLight } from './DoneIconLight';
import { EditedIconLight } from './EditedIconLight';
import { EditIcon } from './EditIcon';
import { EmailPlusIcon } from './EmailPlusIcon';
import { ExcelIcon } from './ExcelIcon';
import { EyeIcon } from './EyeIcon';
import { FilterPinFilledIcon } from './FilterPinFilledIcon';
import { FilterPinIcon } from './FilterPinIcon';
import { FormalCheckIcon } from './FormalCheckIcon';
import { HomeIcon } from './HomeIcon';
import { HomeOutlinedIcon } from './HomeOutlinedIcon';
import { IncomingInvoiceIcon } from './IncomingInvoiceIcon';
import { IncomingInvoiceOutlinedIcon } from './IncomingInvoiceOutlinedIcon';
import { InvoiceIcon } from './InvoiceIcon';
import { InvoiceOutlinedIcon } from './InvoiceOutlinedIcon';
import { JsonIcon } from './JsonIcon';
import { ListErrorIcon } from './ListErrorIcon';
import { ListSuccessIcon } from './ListSuccessIcon';
import { LocationIcon } from './LocationIcon';
import { MoneyIcon } from './MoneyIcon';
import { NoteErrorIcon } from './NoteErrorIcon';
import { NoteSuccessIcon } from './NoteSuccessIcon';
import { NotSettledIcon } from './NotSettledIcon';
import { OutgoingInvoiceIcon } from './OutgoingInvoiceIcon';
import { OutgoingInvoiceOutlinedIcon } from './OutgoingInvoiceOutlinedIcon';
import { ParagraphIcon } from './ParagraphIcon';
import { PartlySettledIcon } from './PartlySettledIcon';
import { PersonCheckedIcon } from './PersonCheckedIcon';
import { PersonErrorIcon } from './PersonErrorIcon';
import { PersonStaleIcon } from './PersonStaleIcon';
import { PieChartIcon } from './PieChartIcon';
import { PieChartOutlinedIcon } from './PieChartOutlinedIcon';
import { PriceCheckIcon } from './PriceCheckIcon';
import { ReturnedGoodsIcon } from './ReturnedGoodsIcon';
import { ScaleBalancedIcon } from './ScaleBalancedIcon';
import { ScaleUnbalancedIcon } from './ScaleUnbalancedIcon';
import { SettingsIcon } from './SettingsIcon';
import { SettingsOutlinedIcon } from './SettingsOutlinedIcon';
import { SettledIcon } from './SettledIcon';
import { SettledNotBilledIcon } from './SettledNotBilledIcon';
import { ShipFromIconLight } from './ShipFromIconLight';
import { ShipFromToIconLight } from './ShipFromToIconLight';
import { ShipToIconLight } from './ShipToIconLight';
import { SignatureCheckIcon } from './SignatureCheckIcon';
import { SignatureIcon } from './SignatureIcon';
import { SupplierIcon } from './SupplierIcon';
import { UserSignatureIcon } from './UserSignatureIcon';

export const CUSTOM_ICONS = {
  customAmountApprovedCheckError: AmountApprovedCheckErrorIcon,
  customAmountApprovedCheckSuccess: AmountApprovedCheckSuccessIcon,
  customAmountCheckError: AmountCheckErrorIcon,
  customAmountCheckSuccess: AmountCheckSuccessIcon,
  customArticleError: ArticleErrorIcon,
  customArticleExistsCheckError: ArticleExistsCheckErrorIcon,
  customArticleExistsCheckSuccess: ArticleExistsCheckSuccessIcon,
  customArticleOutlined: ArticleOutlinedIcon,
  customArticleSuccess: ArticleSuccessIcon,
  customAttention: AttentionIcon,
  customAttentionLight: AttentionIconLight,
  customConsignment: ConsignmentIcon,
  customCostCenter: CostCenterIcon,
  customCreateDeliveryOutlined: CreateDeliveryOutlinedIcon,
  customDataExchangeConfirmed: DataExchangeConfirmedIcon,
  customDataExchangeInterested: DataExchangeInterestedIcon,
  customDataExchangeLive: DataExchangeLiveIcon,
  customDataExchangeOnHold: DataExchangeOnHoldIcon,
  customDataExchangeQrCode: DataExchangeQrCodeIcon,
  customDataExchangeQualification: DataExchangeQualificationIcon,
  customDataExchangeSuccess: DataExchangeSuccessIcon,
  customDataExchangeSupplier: DataExchangeSupplierIcon,
  customDataExchangeTestData: DataExchangeTestDataIcon,
  customDataExchangeTestPhase: DataExchangeTestPhaseIcon,
  customDataExchangeVestigas: DataExchangeVestigasIcon,
  customDeclined: DeclinedIcon,
  customDeclinedLight: DeclinedIconLight,
  customDeclinedLightGrey: DeclinedIconLightGrey,
  customDelivery: DeliveryIcon,
  customDeliveryOutlined: DeliveryOutlinedIcon,
  customDlnCheckError: DlnCheckErrorIcon,
  customDlnCheckSuccess: DlnCheckSuccessIcon,
  customDoneLight: DoneIconLight,
  customEdit: EditIcon,
  customEditedLight: EditedIconLight,
  customEmailPlus: EmailPlusIcon,
  customExcel: ExcelIcon,
  customEye: EyeIcon,
  customFilterPin: FilterPinIcon,
  customFilterPinFilled: FilterPinFilledIcon,
  customFormalCheck: FormalCheckIcon,
  customHome: HomeIcon,
  customHomeOutlined: HomeOutlinedIcon,
  customIncomingInvoice: IncomingInvoiceIcon,
  customIncomingInvoiceOutlined: IncomingInvoiceOutlinedIcon,
  customInvoice: InvoiceIcon,
  customInvoiceOutlined: InvoiceOutlinedIcon,
  customJson: JsonIcon,
  customListError: ListErrorIcon,
  customListSuccess: ListSuccessIcon,
  customLocation: LocationIcon,
  customMoney: MoneyIcon,
  customNoteError: NoteErrorIcon,
  customNoteSuccess: NoteSuccessIcon,
  customNotSettled: NotSettledIcon,
  customOutgoingInvoice: OutgoingInvoiceIcon,
  customOutgoingInvoiceOutlined: OutgoingInvoiceOutlinedIcon,
  customParagraph: ParagraphIcon,
  customPartlySettled: PartlySettledIcon,
  customPersonChecked: PersonCheckedIcon,
  customPersonError: PersonErrorIcon,
  customPersonStale: PersonStaleIcon,
  customPieChart: PieChartIcon,
  customPieChartOutlined: PieChartOutlinedIcon,
  customPriceCheck: PriceCheckIcon,
  customReturnedGoods: ReturnedGoodsIcon,
  customScaleBalanced: ScaleBalancedIcon,
  customScaleUnbalanced: ScaleUnbalancedIcon,
  customSettings: SettingsIcon,
  customSettingsOutlined: SettingsOutlinedIcon,
  customSettled: SettledIcon,
  customSettledNotBilled: SettledNotBilledIcon,
  customShipFromLight: ShipFromIconLight,
  customShipFromToLight: ShipFromToIconLight,
  customShipToLight: ShipToIconLight,
  customSignature: SignatureIcon,
  customSignatureCheck: SignatureCheckIcon,
  customSupplier: SupplierIcon,
  customUserSignature: UserSignatureIcon,
} as const satisfies Record<string, IconGlyph>;
